package org.gymly.api

class PortalSession {
    var apiBase: String = defaultApiBaseUrl()
    var accessToken: String? = null
    /** Preferencia de idioma del usuario autenticado (`es` / `en`). */
    var preferredLocale: String? = null

    fun clearAuth() {
        accessToken = null
        preferredLocale = null
    }
}
